import http from "./http";

// 学生获取作品
export function getScratch(id) {
  return new Promise((resolve, reject) => {
    http.get("/scratch?id=" + id).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

// 获取所有作品
export function get_scratch_all() {
  return new Promise((resolve, reject) => {
    http.get("/scratch/").then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

// 发布社区
export function put_scratch_release_api(id, data) {
  return new Promise((resolve, reject) => {
    http.put("community/scratch?id=" + id, data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

// 老师/校长/管理员获取作品
export function get_management_scratch_api(user, offset, limit) {
  return new Promise((resolve, reject) => {
    http
      .get(
        "scratch/management/v2?user=" +
          user +
          "&offset=" +
          offset +
          "&limit=" +
          limit
      )
      .then(
        (response) => {
          resolve(response);
        },
        (err) => {
          reject(err);
        }
      );
  });
}

//根据ID获取作品
export function get_community_api(tag, offset, limit) {
  return new Promise((resolve, reject) => {
    http
      .get(
        "community/scratch?tag=" + tag + "&offset=" + offset + "&limit=" + limit
      )
      .then(
        (response) => {
          resolve(response);
        },
        (err) => {
          reject(err);
        }
      );
  });
}

//删除作品
export function deleteScratch(id) {
  return new Promise((resolve, reject) => {
    http.delete("scratch?id=" + id).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}
